var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 42,
    viewBox: "0 0 100 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 17.1061H14.3182V29.6863H10.8491V19.8252H4.67215V29.6863H1.20312V17.1061ZM15.6802 29.6863L22.0164 17.1061H25.7686L32.1049 29.6863H28.6005L27.4146 27.2426H20.4766L19.2907 29.6863H15.6802ZM23.9279 20.1006L21.7155 24.6783H26.158L23.9279 20.1006ZM41.4021 25.797H36.9419V29.6863H33.4729V17.1061H41.4021C44.0215 17.1061 46.4463 17.8633 46.4463 21.5118C46.4463 25.1774 43.9684 25.797 41.4021 25.797ZM43.0304 21.5118C43.0304 20.1866 42.3401 19.8768 41.5083 19.8768H36.9419V23.1295H41.5083C42.3401 23.1295 43.0304 22.8197 43.0304 21.5118Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7603 12.7233V21.6207L65.1674 12.7233H68.6541V25.3035H65.4506V16.6471L59.0258 25.3035H55.5391V12.7233H58.7603ZM80.7063 12.7233H84.1753V25.3035H80.7063V20.3988H74.5293V25.3035H71.0603V12.7233H74.5293V17.628H80.7063V12.7233ZM90.0507 15.4424V25.3035H86.5817V12.7233H98.0508V15.4424H90.0507Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.738 11.8131C67.732 11.801 67.7262 11.789 67.7201 11.7771C65.6079 7.54236 60.3653 5.77434 56.0101 7.82807C51.655 9.88182 49.8366 14.9795 51.9488 19.2143C51.9548 19.2262 51.9609 19.2382 51.9669 19.2503L47.9856 21.1277C47.9796 21.1156 47.9736 21.1037 47.9676 21.0917C44.789 14.7189 47.5253 7.04749 54.0793 3.95689C60.6332 0.866278 68.5228 3.52693 71.7014 9.89955C71.7074 9.91159 71.7132 9.92364 71.7193 9.93569L67.738 11.8131Z",
    fill: "#B63940"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7797 23.1321C48.7854 23.1433 48.7911 23.1545 48.7967 23.1658C50.6105 26.8024 48.982 31.7034 44.3939 33.867C39.8056 36.0306 34.8394 34.2396 33.0256 30.603C33.0199 30.5918 33.0142 30.5804 33.0088 30.5691L29.0273 32.4467C29.033 32.4578 29.0387 32.4692 29.0442 32.4804C32.0341 38.4749 39.7707 40.8288 46.3247 37.7381C52.8785 34.6474 55.7679 27.2827 52.778 21.2884C52.7725 21.2771 52.7668 21.2659 52.7612 21.2545L48.7797 23.1321Z",
    fill: "#B63940"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1121 28.1256V29.1252H97.4313V32.2855H96.1016V28.1256H99.1121Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5395 29.748V30.7438H92.4088V29.748H94.5395ZM92.8942 28.1256V32.2855H91.5645V28.1256H92.8942ZM95.3918 28.1256V32.2855H94.0581V28.1256H95.3918Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.361 30.5399L89.5369 28.1255H90.8666V32.2854H89.5369V29.8633L88.361 32.2854H87.0274V28.1255H88.361V30.5399Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2045 28.1255V32.2854H83.8709V28.1255H85.2045ZM86.554 28.1255V29.1174H82.5451V28.1255H86.554Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5259 32.3611C80.1787 32.3611 79.8683 32.3086 79.5947 32.2035C79.3212 32.0959 79.0897 31.9485 78.9003 31.7614C78.7135 31.5743 78.5702 31.359 78.4702 31.1155C78.3729 30.872 78.3242 30.6144 78.3242 30.3427V30.1966C78.3242 29.8916 78.3676 29.6097 78.4544 29.3508C78.5412 29.0894 78.6701 28.8613 78.8411 28.6665C79.0121 28.4717 79.2265 28.3205 79.4843 28.2128C79.742 28.1026 80.0419 28.0475 80.3839 28.0475C80.6864 28.0475 80.9573 28.0949 81.1967 28.1897C81.4361 28.2846 81.6386 28.4204 81.8043 28.5973C81.9727 28.7741 82.1003 28.9881 82.1871 29.2393C82.2765 29.4905 82.3212 29.7724 82.3212 30.0851V30.6118H78.8332V29.8006H81.0231V29.7007C81.0257 29.5623 81.0007 29.4444 80.9481 29.347C80.8981 29.2496 80.8245 29.1752 80.7272 29.124C80.6298 29.0727 80.5115 29.0471 80.372 29.0471C80.2274 29.0471 80.1077 29.0778 80.013 29.1394C79.9209 29.2009 79.8486 29.2855 79.796 29.3931C79.746 29.4982 79.7105 29.6199 79.6894 29.7583C79.6684 29.8967 79.6579 30.0428 79.6579 30.1966V30.3427C79.6579 30.4965 79.6789 30.6362 79.721 30.7618C79.7657 30.8874 79.8288 30.995 79.9104 31.0847C79.9946 31.1719 80.0945 31.2398 80.2103 31.2885C80.3286 31.3372 80.4628 31.3615 80.6127 31.3615C80.7942 31.3615 80.9731 31.3282 81.1493 31.2616C81.3256 31.1949 81.4768 31.0847 81.6031 30.9309L82.2068 31.6307C82.12 31.7511 81.9964 31.8678 81.8359 31.9805C81.6781 32.0933 81.4887 32.1856 81.2677 32.2573C81.0468 32.3265 80.7995 32.3611 80.5259 32.3611Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1375 28.1256V29.1252H76.4567V32.2855H75.127V28.1256H78.1375Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9391 28.9241V33.8836H70.6094V28.1244H71.8483L71.9391 28.9241ZM74.559 30.1543V30.2351C74.559 30.5375 74.5235 30.8182 74.4525 31.077C74.3815 31.3359 74.2763 31.5615 74.1368 31.7537C73.9974 31.9459 73.8238 32.0959 73.616 32.2035C73.4108 32.3086 73.1728 32.3611 72.9018 32.3611C72.6467 32.3611 72.427 32.306 72.2429 32.1958C72.0588 32.0856 71.9049 31.9331 71.7813 31.7383C71.6576 31.5435 71.5577 31.3205 71.4814 31.0694C71.4051 30.8182 71.3446 30.5529 71.2999 30.2735V30.1697C71.3446 29.8698 71.4051 29.5917 71.4814 29.3354C71.5577 29.0766 71.6576 28.851 71.7813 28.6588C71.9049 28.4665 72.0574 28.3166 72.239 28.209C72.4231 28.1013 72.6427 28.0475 72.8979 28.0475C73.1688 28.0475 73.4069 28.0975 73.6121 28.1974C73.8199 28.2974 73.9935 28.4409 74.1329 28.628C74.2749 28.8126 74.3815 29.0343 74.4525 29.2931C74.5235 29.552 74.559 29.8391 74.559 30.1543ZM73.2293 30.2351V30.1543C73.2293 29.9929 73.2175 29.8455 73.1938 29.7122C73.1701 29.5764 73.132 29.4585 73.0794 29.3585C73.0294 29.2585 72.9623 29.1816 72.8782 29.1278C72.794 29.074 72.6901 29.0471 72.5664 29.0471C72.4244 29.0471 72.3047 29.0689 72.2074 29.1124C72.1127 29.1535 72.0364 29.2175 71.9785 29.3047C71.9233 29.3893 71.8838 29.4956 71.8602 29.6238C71.8391 29.7494 71.8299 29.8967 71.8325 30.0659V30.3812C71.8273 30.576 71.847 30.7477 71.8917 30.8963C71.9364 31.0424 72.014 31.1565 72.1245 31.2385C72.235 31.3205 72.3849 31.3615 72.5743 31.3615C72.7006 31.3615 72.8058 31.3334 72.89 31.277C72.9742 31.218 73.0412 31.1373 73.0912 31.0348C73.1412 30.9297 73.1767 30.8092 73.1978 30.6734C73.2188 30.5375 73.2293 30.3914 73.2293 30.2351Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5221 31.2385V29.5238C68.5221 29.4059 68.505 29.3047 68.4708 29.2201C68.4366 29.1355 68.3827 29.0702 68.309 29.024C68.2354 28.9753 68.1367 28.951 68.0131 28.951C67.9131 28.951 67.8277 28.9676 67.7566 29.001C67.6856 29.0343 67.6317 29.0843 67.5949 29.1509C67.558 29.2175 67.5396 29.3021 67.5396 29.4046H66.2099C66.2099 29.2124 66.2533 29.0343 66.3401 28.8702C66.4296 28.7036 66.5558 28.5588 66.7189 28.4358C66.8846 28.3128 67.0819 28.2179 67.3108 28.1513C67.5423 28.0821 67.8 28.0475 68.0841 28.0475C68.4235 28.0475 68.726 28.1026 68.9916 28.2128C69.2599 28.323 69.4717 28.4883 69.6269 28.7088C69.7821 28.9266 69.8597 29.2009 69.8597 29.5315V31.2347C69.8597 31.5064 69.8755 31.7127 69.907 31.8537C69.9386 31.9921 69.9833 32.1138 70.0412 32.2189V32.2843H68.7075C68.6444 32.1561 68.5971 31.9998 68.5655 31.8152C68.5366 31.6281 68.5221 31.4359 68.5221 31.2385ZM68.6839 29.743L68.6918 30.435H68.1039C67.9802 30.435 67.875 30.4517 67.7882 30.485C67.704 30.5183 67.6356 30.5644 67.583 30.6234C67.533 30.6798 67.4962 30.7438 67.4725 30.8156C67.4515 30.8874 67.441 30.963 67.441 31.0424C67.441 31.1193 67.4594 31.1885 67.4962 31.2501C67.5357 31.309 67.5883 31.3551 67.654 31.3885C67.7198 31.4218 67.7935 31.4384 67.875 31.4384C68.0223 31.4384 68.1473 31.4115 68.2498 31.3577C68.3551 31.3013 68.4353 31.2334 68.4905 31.1539C68.5458 31.0745 68.5734 31.0002 68.5734 30.9309L68.8654 31.4615C68.8128 31.564 68.7523 31.6678 68.6839 31.7729C68.6181 31.878 68.5353 31.9754 68.4353 32.0651C68.338 32.1523 68.2183 32.224 68.0762 32.2804C67.9342 32.3342 67.7619 32.3611 67.5593 32.3611C67.2963 32.3611 67.0543 32.3086 66.8333 32.2035C66.615 32.0984 66.4401 31.9523 66.3086 31.7652C66.177 31.5756 66.1113 31.3577 66.1113 31.1116C66.1113 30.8963 66.1507 30.7041 66.2296 30.535C66.3112 30.3658 66.4335 30.2223 66.5966 30.1044C66.7597 29.9865 66.9675 29.8967 67.22 29.8352C67.4725 29.7737 67.7698 29.743 68.1117 29.743H68.6839Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5207 28.1256V32.2855H63.1871V28.1256H64.5207ZM65.8702 28.1256V29.1175H61.8613V28.1256H65.8702Z",
    fill: "#8586A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8903 30.5399L58.0661 28.1255H59.3958V32.2854H58.0661V29.8633L56.8903 32.2854H55.5566V28.1255H56.8903V30.5399Z",
    fill: "#8586A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_563",
    x: 46.0471,
    y: 2.66858,
    width: 26.2676,
    height: 19.65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.595455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.297727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_563",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_563",
    x: 29.0273,
    y: 21.2545,
    width: 26.1212,
    height: 19.0348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.595455,
    dy: 0.595455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.297727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_563",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_563",
    x: 54.9612,
    y: 28.0475,
    width: 44.7464,
    height: 7.02709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.595455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.297727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.207843 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_563",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/Logo_mobile.925cefae03d368ecc9aea0ba4b1afd4b.svg";
export { ForwardRef as ReactComponent };